import * as React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import BasicList from "../../common/layout/BasicList";
import {
    setDriver,
    setSelectedDrivers,
    toggleDriversPanel,
    reloadDrivers,
    addNewDriver,
} from "../../../config/redux/drivers/driversActions";
import { driversColumns } from "./driversColumns";
import { getDrivers } from "../../../connectors/drivers/connectors/index";
import { useTranslation } from 'react-i18next';

const DriversList: React.FC = () => {
    const { t } = useTranslation('admin');
    const {
        selectedDrivers,
        activeDriver,
        driverPanelOpen,
        reloadDriversList,
        addDriver,
    } = useSelector((state: RootStateOrAny) => state.drivers);

    const parseDriver = (items: Array<any>) => {
        const drivers = items.map((item: any) => item.userData);
        return drivers;
    };

    return (
        <>
            <BasicList
                setSelectedItems={setSelectedDrivers}
                setActiveItem={setDriver}
                togglePanel={toggleDriversPanel}
                reload={reloadDrivers}
                editList={addNewDriver}
                getData={getDrivers}
                activeItem={activeDriver}
                panelOpen={driverPanelOpen}
                selectedItems={selectedDrivers}
                removeItems={reloadDriversList}
                listEdited={addDriver}
                columns={driversColumns(t)}
                parseItems={parseDriver}
            />
        </>
    );
};

export default DriversList;


